module.exports = __webpack_public_path__ + "img/plants.427d23fe.svg";